var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11063_17251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.5H3.33333L1 5.7C1 6.98893 2.0444 8.03333 3.33333 8.03333C4.62227 8.03333 5.66667 6.98893 5.66667 5.7C5.66667 6.98893 6.71107 8.03333 8 8.03333C9.28893 8.03333 10.3333 6.98893 10.3333 5.7C10.3333 6.98893 11.3777 8.03333 12.6667 8.03333C13.9556 8.03333 15 6.98893 15 5.7L12.6667 1.5Z",
    stroke: "#A5AEBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1329 9.90039V15.5004H2.86621V9.90039",
    stroke: "#A5AEBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59961 15.5009V11.7676H9.39961V15.5009",
    stroke: "#A5AEBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11063_17251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.5cead503.svg";
export { ForwardRef as ReactComponent };